import hasReceiptCalculations from "./hasReceiptCalculations";
import { documentMark } from "@/utils/documentMark";

// Printing logic for WarehousePurchaseReceiptDialog.
// Expects the component to expose: editedItem, groceries, note,
// deliveryDate, dispatcherNumber, users (from hasWarehouseUsers).
export default {
  mixins: [hasReceiptCalculations],
  computed: {
    printItems() {
      return this.groceries.map((item) => ({
        ...item,
        orderedQty: Number(item.amount) || 0,
        deliveredNow: this.isFullyDelivered(item)
          ? this.getGroceryDelivered(item)
          : this.getCurrentReceiptAmount(item),
        formattedPrice: this.formatOptionalMoney(this.getCurrentUnitPrice(item)),
        lineValue: this.formatOptionalMoney(this.getCurrentLineValue(item)),
      }));
    },
    printHeaders() {
      return [
        { text: this.$t("r_b"), value: "num" },
        { text: this.$t("code"), align: "start", value: "code" },
        { text: this.$t("title"), align: "start", value: "name" },
        { text: this.$t("warehouse.ordered"), align: "start", value: "orderedQty" },
        {
          text: this.$t("warehouse.delivered"),
          align: "start",
          value: "deliveredNow",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    printReceipt() {
      const deliveredDate =
        this.$t("warehouse.shipping_date") +
        ":" +
        this.localeDate(this.deliveryDate || new Date());
      const orderDate =
        this.$t("warehouse.ordering_date") +
        ":" +
        this.localeDate(this.editedItem.document_date);
      const orderNumber =
        this.$t("warehouse.order_number") + ": " + documentMark(this.editedItem);
      const deliveredNumber =
        this.$t("warehouse.invoice_number") + ": " + this.dispatcherNumber;
      const note = this.note
        ? `<div style="font-size: 12px;margin-top: 20px;">${this.$t("note")}: ${this.note}</div>`
        : "";

      this.printDocument({
        title: this.$t("warehouse.entry_sheet") + ` ${documentMark(this.editedItem)}`,
        hideDatetime: true,
        beforeTitleHtml: `
          <div style="display: flex;justify-content: space-between;font-size: 16px;margin-top: 20px;">
            <div>${orderNumber}</div><div>${deliveredNumber}</div>
          </div>
          <div style="display: flex;justify-content: space-between;font-size: 16px;">
            <div>${orderDate}</div><div>${deliveredDate}</div>
          </div>`,
        company1: {
          id: this.editedItem.customer?.id || 101,
          name: this.toLatin(
            [this.editedItem.customer?.name, this.editedItem.customer?.lastname].join(" ") || ""
          ),
          city: this.toLatin(this.editedItem.customer?.city || ""),
          address: this.toLatin(this.editedItem.customer?.address || ""),
          phone: this.translate(this.editedItem.customer?.phone || ""),
          email: this.translate(this.editedItem.customer?.email || ""),
          printTitle: this.$t("warehouse.orderer"),
        },
        company2: {
          printTitle: this.$t("supplier"),
          name: this.toLatin(this.editedItem.supplier?.name || ""),
          address: this.toLatin(this.editedItem.supplier?.address || ""),
          phone: this.editedItem.supplier?.phone || "",
          email: this.editedItem.supplier?.email || "",
        },
        signature: {
          left: {
            title: this.$t("warehouse.product_delivered_by"),
            name: this.toLatin(this.editedItem.supplier?.name || ""),
          },
          right: {
            title: this.$t("warehouse.received_by"),
            name: this.toLatin(this.getSelectedUserName(this.editedItem.received_by)),
          },
        },
        tables: [
          {
            headers: [
              ...this.printHeaders,
              { text: this.$t("unit_of_measurment"), value: "measure" },
              { text: this.$t("price") + " " + this.restaurantCurrency, value: "formattedPrice", align: "right" },
              { text: this.$t("amount") + " " + this.restaurantCurrency, value: "lineValue", align: "right" },
            ],
            items: this.printItems.map((item, index) => ({
              ...item,
              num: index + 1,
              name: this.toLatin(item.name),
            })),
          },
        ],
        afterTableHtml: note,
      });
    },
  },
};
